// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1666":"67f5cff1","3327":"2c88f91d"}[chunkId] + ".chunk.css";
};